<template>
  <a-form-item class="confirm-password-input">
    <label
      v-if="label"
      class="input-label confirm-password-input-label"
      :class="{required}"
      for="password"
    >{{label}}</label>
    <a-input-password
      name="confirm-password"
      v-decorator="[
        'confirmPassword',
        {
          rules: [
            {
              required: this.required,
              message: $t('validation.required'),
            },
            {
              validator: compareToFirstPassword,
            },
          ],
        },
      ]"
      type="password"
      :placeholder="placeholder"
      @change="handleConfirmChange"
    />
  </a-form-item>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    required: {
      type: Boolean,
      default: true,
    },
  },
  inject: {
    form: { type: Object },
    theme: { type: Object, default: {} },
  },
  data() {
    return {
      dirty: false,
    };
  },
  computed: {
    label() {
      return this.theme.mode !== 'label' ? '' : this.$t('confirm.password');
    },
    placeholder() {
      return this.theme.mode === 'label' ? '' : this.$t('confirm.password');
    },
  },
  methods: {
    handleConfirmChange(e) {
      const { value } = e.target;
      this.dirty = this.dirty || !!value;
      this.$emit('change', value);
    },
    compareToFirstPassword(rule, value, callback) {
      const { form } = this;
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('confirm.password.inconsistent'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-password-input {
  flex: 1;
}

.input-label {
  text-align: left;
}
</style>


<style lang="scss">
.confirm-password-input {
  .ant-form-item-children {
    display: flex;
    flex-direction: column;
  }
}
</style>
